import { BannerPropsModel } from "@models/banner";
import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

const Banner: React.FC<BannerPropsModel> = ({ bannerData }) => {
  const { text, ctaLink, ctaText, showBanner } = bannerData;

  if (!showBanner) {
    return null;
  }

  return (
    <div className="bg-[#ffeff1]  text-center  items-center px-4 lg:px-8 py-0.5  text-dark-purple-50 text-xs md:text-sm ont-normal leading-[18px] xl:text-base xl:leading-[26px]">
      {text}.&nbsp;
      {ctaLink && ctaText && (
        <a
          href={ctaLink}
          target="_blank"
          className="text-blue-500"
          rel="noreferrer"
        >
          {ctaText}&nbsp;&nbsp;&nbsp;
          <FaExternalLinkAlt className="inline-block text-sm mb-1" />
        </a>
      )}
      &nbsp;
    </div>
  );
};

export default Banner;
